import React from "../_snowpack/pkg/react.js";
import App from "../components/app.js";
import MainSideBarContainer, {
  SidebarToggleButton
} from "../components/main-sidebar-container.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import Stack from "../components/stack.js";
import ProductSidebar from "../components/product-sidebar.js";
import ThumbnailSlider from "../components/thumbnail-slider.js";
import ContentModules from "../components/content-modules.js";
import {t} from "../common/i18n.js";
import {
  getTranslatedName,
  isStepsBasedConfig,
  withAttrs
} from "../common/utils.js";
import {Title} from "../components/typo.js";
import ProductStepsConfig from "../components/product-steps-config.js";
import {ProductStoreProvider} from "../stores/product.js";
import {media} from "../components/theme.js";
import BreadCrumb from "../components/breadcrumb.js";
export default function Product(props) {
  const {product} = props;
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(ProductStoreProvider, {
    ...props
  }, /* @__PURE__ */ React.createElement(Container, {
    title: /* @__PURE__ */ React.createElement(Headline, null, getTranslatedName(product.page)),
    main: /* @__PURE__ */ React.createElement(Main, {
      ...props
    }),
    sidebar: /* @__PURE__ */ React.createElement(ProductSidebar, null)
  })));
}
function Main(props) {
  const {product} = props;
  const stepsBasedConfig = isStepsBasedConfig(product);
  return /* @__PURE__ */ React.createElement(MainContainer, null, /* @__PURE__ */ React.createElement(MainHero, {
    ...product
  }), product.page.content.content_hero_modules && /* @__PURE__ */ React.createElement(ContentModules, {
    modules: product.page.content.content_hero_modules,
    isProductPage: true
  }), stepsBasedConfig && /* @__PURE__ */ React.createElement(ProductStepsConfig, null), !stepsBasedConfig && /* @__PURE__ */ React.createElement(SidebarToggleButton, null, t("Produkt konfigurieren")), /* @__PURE__ */ React.createElement(ContentModules, {
    modules: product.page.content.content_modules,
    isProductPage: true
  }));
}
function MainHero(props) {
  const {page, category} = props;
  const [pageProduct] = page.content.product;
  const color = getCategoryColor(category);
  const {hero} = pageProduct;
  if (!hero)
    return null;
  const [heroModule] = hero || [];
  const {images, ...rest} = heroModule;
  const hasBreadcrumb = !!category;
  return /* @__PURE__ */ React.createElement(HeroContainer, {
    hasBreadcrumb
  }, hasBreadcrumb && /* @__PURE__ */ React.createElement(BreadCrumb, {
    category,
    page
  }), images && /* @__PURE__ */ React.createElement(ThumbnailSlider, {
    images: images.slice(0, 6),
    color,
    ...rest
  }));
}
function getCategoryColor(category) {
  if (!category)
    return;
  return category.content.color.color;
}
const Container = styled(MainSideBarContainer)``;
const MainContainer = styled(Stack)``;
const HeroContainer = styled.div`
  margin-top: 45px;

  ${({hasBreadcrumb}) => hasBreadcrumb && `margin-top: 10px;`}

  ${media.mobile} {
    margin-top: 0px;
  }
`;
const Headline = styled(withAttrs(Title, {level: 2}))`
  font-size: 30px;
`;
